import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import React from 'react';
import FactorActionComponent from 'components/FactorActionComponent/FactorActionComponent';
import { CREDIT_CARD_DEBT_PAYOFF } from 'types/morph.pagePosition.constants';
import { useEventHandler } from 'hook/event.hook';

const CreditCardDebtPayoffModuleView = props => {
  const { history, offer, moduleHeading, moduleMetadata, selectedFactor } =
    props;
  const linkPath = '/debtPayOffCalculator';
  const eventHandler = useEventHandler();

  return (
    <FlexContainer className={'flex-column margT6'}>
      <FlexContainer className={'flex-column'}>
        <FactorActionComponent
          text={
            'See a potential credit score impact when you pay down some or all of your credit card debt.'
          }
          icon={'payOff'}
          url={linkPath}
          history={history}
          offerModulePosition={1}
          selectedFactor={selectedFactor}
          offer={offer}
          eventHandler={eventHandler}
          moduleHeading={moduleHeading}
          moduleMetadata={moduleMetadata}
          seenOfferModuleName={CREDIT_CARD_DEBT_PAYOFF + ' - '}
          clickType={'Launch Card Debt Calculator'}
          avoidSeenOfferPixel
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default CreditCardDebtPayoffModuleView;
